import { render } from "./ResourcesContainer.vue?vue&type=template&id=427f433e&scoped=true"
import script from "./ResourcesContainer.vue?vue&type=script&lang=js"
export * from "./ResourcesContainer.vue?vue&type=script&lang=js"

import "./ResourcesContainer.vue?vue&type=style&index=0&id=427f433e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-427f433e"]])

export default __exports__